"use strict";
/**
 * HRIS (Human Resources Information System) constants.
 *
 * These are currently hardcoded values. Some should eventually become
 * configurable via CompanySettings (see GH issue for reorganization).
 *
 * Categories:
 * - Mexican labor law (not configurable)
 * - Company policy (should become configurable)
 * - Derived/calculated (computed from other constants)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEEKS_PER_MONTH = exports.WEEK_WORK_DAYS = exports.DAILY_WORK_HOURS = exports.MONTH_WORK_DAYS = exports.MONTH_DAYS = exports.WEEKS_IN_MONTH = exports.AVERAGE_WORK_DAYS_PER_MONTH = exports.EXCELLENCE_BONUS_RATE = exports.EXCELLENCE_BONUS_MIN_CLOSINGS = exports.DEDUCTION_INVALID_WITHDRAWAL = exports.DEDUCTION_INVALID_CLOSING = exports.BONUS_PER_CLOSING = exports.BONUS_SMALL_CLOSING = exports.BONUS_LARGE_CLOSING = exports.CLOSING_LARGE_THRESHOLD = exports.COMMISSION_SENIORITY_BONUS_PER_SEMESTER = exports.YEAR_END_BONUS_DAYS = exports.ANNUAL_RAISE_PERCENT = exports.WORKING_DAYS_IN_A_WEEK = exports.MAX_DOUBLE_PLAY_WORK_WEEK_LIMIT = exports.MAX_WORK_WEEK_LIMIT = exports.HOLIDAY_OR_REST_EXTRA_PAY_PERCENTAGE = exports.SUNDAY_BONUS_PERCENTAGE = exports.VACATION_BONUS_PERCENTAGE = void 0;
exports.calculateHourlyRate = calculateHourlyRate;
// ── Mexican Labor Law (not configurable) ──
/** Prima vacacional: 25% of vacation days' salary (Art. 80 LFT) */
exports.VACATION_BONUS_PERCENTAGE = 0.25;
/** Sunday premium: 25% extra for working Sundays (Art. 71 LFT) */
exports.SUNDAY_BONUS_PERCENTAGE = 0.25;
/** Holiday or rest day extra pay: 200% (double pay) (Art. 75 LFT) */
exports.HOLIDAY_OR_REST_EXTRA_PAY_PERCENTAGE = 2;
// LEGAL_VACATIONS is in time-off.constants.ts (already in shared)
// ── Company Policy (TODO: move to CompanySettings — see GH#XX) ──
/** Maximum legal work week in hours (Art. 61 LFT: 48 for daytime) */
exports.MAX_WORK_WEEK_LIMIT = 48;
/** Maximum overtime threshold for double pay (48 + 9 = 57 hrs) */
exports.MAX_DOUBLE_PLAY_WORK_WEEK_LIMIT = 57;
/** Working days per week (company policy: 6 days) */
exports.WORKING_DAYS_IN_A_WEEK = 6;
/** Annual salary raise percentage per year of seniority */
exports.ANNUAL_RAISE_PERCENT = 0.02;
/** Year-end bonus (aguinaldo) days (legal minimum: 15, Art. 87 LFT) */
exports.YEAR_END_BONUS_DAYS = 15;
/** Commission seniority bonus: 5% increase per semester */
exports.COMMISSION_SENIORITY_BONUS_PER_SEMESTER = 0.05;
// ── Reception Bonus (Bono de recepción) ──
// Legacy thresholds (kept for historical data)
exports.CLOSING_LARGE_THRESHOLD = 10000;
exports.BONUS_LARGE_CLOSING = 100;
exports.BONUS_SMALL_CLOSING = 50;
// Current policy
exports.BONUS_PER_CLOSING = 60;
exports.DEDUCTION_INVALID_CLOSING = 40;
exports.DEDUCTION_INVALID_WITHDRAWAL = 20;
exports.EXCELLENCE_BONUS_MIN_CLOSINGS = 3;
exports.EXCELLENCE_BONUS_RATE = 0.25;
// ── Derived / Calculated ──
/** Average working days per month (365/12/7 × 6) */
exports.AVERAGE_WORK_DAYS_PER_MONTH = (365 / 12 / 7) * exports.WORKING_DAYS_IN_A_WEEK;
/** Weeks in a month (365/12/7) */
exports.WEEKS_IN_MONTH = 4.34524;
/** Calendar days in a month (used for nominal daily calculations) */
exports.MONTH_DAYS = 30;
/** Working days in a month (6 × weeks) */
exports.MONTH_WORK_DAYS = 6 * exports.WEEKS_IN_MONTH;
/** Standard daily working hours (48/6) */
exports.DAILY_WORK_HOURS = 8;
/** Working days in a week (alias for clarity) */
exports.WEEK_WORK_DAYS = 6;
// ── Utility Functions ──
/** Weeks per month (52 / 12 ≈ 4.333) — used for hourly rate calculation */
exports.WEEKS_PER_MONTH = 52 / 12;
/**
 * Calculate hourly rate from monthly fixed income.
 * Formula: income / (52/12) / 48
 * Divides by work-weeks per month and max weekly hours (48).
 * Hourly workers are NOT paid for rest days, so we use actual work hours, not calendar days.
 */
function calculateHourlyRate(jobFixedIncome) {
    if (!jobFixedIncome || jobFixedIncome <= 0)
        return 0;
    return Math.round((jobFixedIncome / exports.WEEKS_PER_MONTH / exports.MAX_WORK_WEEK_LIMIT) * 100) / 100;
}
